import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "../../../.././../../assets/svg/solobuilder/close-icon.svg";
import { guessTextColor } from "../../helpers/guessTextColor";
import { Dropdown } from "../border/BorderPopper";
import { Dropdown as FontFamilyDropDown } from "../../../../forms/formBuilder/PropertiesPanel/layout-components/helpers/constants";
import LeftAlignment from "../../../.././../../assets/svg/solobuilder/leftAlignmentSVG";
import CenterALignment from "../../../../../../assets/svg/solobuilder/centerAlignment";
import RightAlignment from "../../../../../../assets/svg/solobuilder/rightAlignment";
import JustifyAlignment from "../../../../../../assets/svg/solobuilder/justifyAlignment";
import { onsetClrPicContext, onSetFontStylesVisibility } from "../../../../../../stateManager/store/common/action";
import { AppState } from "../../../../../../stateManager/store";
import { data } from "../data";
import { GetFontFamilyList } from "../layout-components/helpers/getFontFamilyList";
import { rgbToHexWithOpacity } from "../../../../../../utils/rgbToHex";
import { ColorPicker } from "../ColorPicker";

const restrictlist = ['BarChart','LineChart', 'DateRangePicker'];

const FontStylesPopper = ((props: any) => {
    const { isCoreV3 } = useSelector((state: any) => state.formJson);
    const { fontStylesContext, close, open, onChange, setFontStylesContext, component } = props;
    const { label, value, where, placeholder, key, category } = fontStylesContext;
    const { colorPickerContext, fontStylesVisibility } = useSelector((state: any) => state.common);
    let colorValue = colorPickerContext?.value
    const [values, setValues] = useState(value || {})
    const ref = useRef(null)
    const dispatch = useDispatch()
    const { gridStyles } = useSelector((state: AppState) => state.formJson)
    const customFontFamily = gridStyles.common?.fontFamily || []
    const restrictWidget =  restrictlist.includes(component.type)
    useEffect(() => {
        if (colorValue) {
            setValues((val: any) => ({ ...val, color: colorValue }));
        }
        document.addEventListener('keydown', detectKeyDown)
        return () => {
            document.removeEventListener('keydown', detectKeyDown);
        }
    }, [colorValue])

    useEffect(() => {
        setFontStylesContext((value: any) => ({ ...value, value: values }))
        onChange(where, values)
    }, [values])

    const detectKeyDown = (e:KeyboardEvent) => {
        if (e.key === "Escape") {
            close();
        }
    }

    const weightOptions = [
        {
            label: "100",
            value: 100,
        },
        {
            label: "200",
            value: 200,
        },
        {
            label: "300",
            value: 300,
        },
        {
            label: "400",
            value: 400,
        },
        {
            label: "500",
            value: 500,
        },
        {
            label: "600",
            value: 600,
        },
        {
            label: "700",
            value: 700,
        },
        {
            label: "800",
            value: 800,
        },
        {
            label: "900",
            value: 900,
        },
        {
            label: "bold",
            value: "bold",
        },
        {
            label: "bolder",
            value: "bolder",
        },
        {
            label: "lighter",
            value: "lighter",
        },
        {
            label: "normal",
            value: "normal",
        },
    ]

    const optionList = GetFontFamilyList()

    const setAlignment = (alignment: string) => {
        if(!restrictWidget){
            setValues((val: any) => ({ ...val, ["alignment"]: alignment }));
        }
    }

    const setCase = (value: string) => {
        if(!restrictWidget){
        setValues((val: any) => ({ ...val, ["case"]: value }));
        }
    }

    const setDecoration = (decoration: string) => {
        if(!restrictWidget){
        setValues((val: any) => ({ ...val, ["decoration"]: decoration }));
        }
    }

    useEffect(() => {
        setFontStylesContext((value: any) => ({ ...value, value: values }))
        onChange(where, values)
    }, [values])

    const disableinput = () => {
        return restrictWidget ? true : false;
    }
    
    const disableCursor = () => {
        return restrictWidget ? "not-allowed" : "pointer";
    };

    return (
        <div className="custom-fontstyles" data-test-id="custom-fontstyles" style={{ bottom: 10 }} ref={ref} onClick={(e) => e.stopPropagation()}>
            <div className="w-full flex justify-between items-center text-xs font-semibold"
                style={{ background: "#EFF0F4", height: "30px", width: "100%", padding: "0px 10px" }}>
                <div className="text-base text-black">{label}</div>
                <CloseIcon className="cursor-pointer" onClick={() => { close() }}></CloseIcon>
            </div>
        <div style={{padding: "0px 10px 10px"}}>
            <div className="panel-div">
                <div className="panel-label">Size</div>
                <div className="flex" style={{ gap: "7px" }}>
                    <input
                        type="number"
                        style={{width:"131px"}}
                        className="panel-input flex items-center"
                        data-test-id={`fontstylesPopper-size`}
                        onChange={((e: any) => {
                            const value = e.target.value
                            setValues((val: any) => ({ ...val, ["size"]: value }))
                        })}
                        value={values?.size && values.size}
                    ></input>
                </div>
            </div>

            <div className="panel-div">
                <div className="panel-label">Weight</div>
                <div className="flex" style={{ gap: "7px" }}>
                    <Dropdown type={component?.type} label="Weight" options={weightOptions} onchange={((e: any) => { setValues((val: any) => ({ ...val, ["weight"]: e.value })) })} value={values.weight}></Dropdown>
                </div>
            </div>
            {/* <div className="flex flex-row items-center" style={{ marginBottom: "10px", marginTop: "10px", padding: "0px 7px", justifyContent: "space-between" }}>
                <div
                    className="text-xs font-semibold"
                    style={{ fontSize: "11px", fontWeight: 600, color: "#282B31" }}
                >
                    Family
                </div>
                <div className="flex" style={{ gap: "7px", width: "130px" }}>
                    <FontFamilyDropDown
                        options={
                            optionList
                        }
                        width={130}
                        type="fontFamily"
                        selected={{ name: values?.family || 'Inherit' }}
                        onChange={(option) => {
                            const merggedArray = [...optionList?.customFonts, ...optionList?.systemFonts]
                            const item = merggedArray.find((item: any) => item.name === option.name)
                            if (item) {
                                const value = item.name
                                setValues((val: any) => ({ ...val, ["family"]: value }))
                            }
                        }}
                    />
                </div>
            </div> */}
            <div><ColorPicker pickerkey="font-color" label="Color" value={values?.color ? values.color : "white"} open={open} close={()=>dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: false }))}
            visibility={colorPickerContext?.visibility} width="131px"/></div>

            <div className="panel-div">
                <div className="panel-label">Alignment</div>
                <div className="flex" style={{ gap: "6px", }} >
                    <div onClick={(() => { setAlignment("left") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.alignment === "left"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <LeftAlignment strokeOpacity={values.alignment === "left" ? "1" : "0.6"} color={values.alignment === "left" ? "#282B31" : "#7D8492"} />
                    </div>
                    <div onClick={(() => { setAlignment("center") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.alignment === "center"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <CenterALignment strokeOpacity={values.alignment === "center" ? "1" : "0.6"} color={values.alignment === "center" ? "#282B31" : "#7D8492"} ></CenterALignment>
                    </div>
                    <div onClick={(() => { setAlignment("right") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.alignment === "right"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <RightAlignment strokeOpacity={values.alignment === "right" ? "1" : "0.6"} color={values.alignment === "right" ? "#282B31" : "#7D8492"} ></RightAlignment>
                    </div>
                    <div onClick={(() => { setAlignment("justify") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.alignment === "justify"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <JustifyAlignment strokeOpacity={values.alignment === "justify" ? "1" : "0.6"} color={values.alignment === "justify" ? "#282B31" : "#7D8492"} ></JustifyAlignment>
                    </div>
                </div>
            </div>

            <div className="panel-div">
                <div className="panel-label">Case</div>
                <div className="flex" style={{ gap: "6px", }} >
                    <div onClick={(() => { setCase("none") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.case === "none"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1H7.31333" stroke={values.case === "none" ? "#282B31" : "#7D8492"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div onClick={(() => { setCase("uppercase") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.case === "uppercase"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <span style={{ fontWeight: 600, fontSize: "11px", color: values.case === "uppercase" ? "#282B31" : "#7D8492" }}>AR</span>
                    </div>
                    <div onClick={(() => { setCase("capitalize") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.case === "capitalize"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <span style={{ fontWeight: 600, fontSize: "11px", color: values.case === "capitalize" ? "#282B31" : "#7D8492" }}>Ar</span>
                    </div>
                    <div onClick={(() => { setCase("lowercase") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.case === "lowercase"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px", cursor: disableCursor() }}>
                        <span style={{ fontWeight: 600, fontSize: "11px", color: values.case === "lowercase" ? "#282B31" : "#7D8492" }}>ar</span>
                    </div>
                </div>
            </div>

            <div className="panel-div">
                <div className="panel-label">Decoration</div>
                <div className="flex" style={{ gap: "6px", }} >
                    <div onClick={(() => { setDecoration("none") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.decoration === "none"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px" ,cursor: disableCursor()}}>
                        <svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1H7.31333" stroke={values.decoration === "none" ? "#282B31" : "#7D8492"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div onClick={(() => { setDecoration("underline") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.decoration === "underline"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px" ,cursor: disableCursor()}}>
                        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.17725 10H7.99826" stroke={values.decoration === "underline" ? "#282B31" : "#7D8492"} stroke-opacity={values.decoration === "underline" ? "1" : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.50594 8.06263C3.31749 8.06263 2.43407 7.78072 1.85569 7.2169C1.28523 6.65308 1 5.81862 1 4.71354V0H2.43803V4.69098C2.43803 5.42019 2.60441 5.96898 2.93718 6.33734C3.26995 6.7057 3.79287 6.88988 4.50594 6.88988C5.18732 6.88988 5.70232 6.7057 6.05093 6.33734C6.39955 5.96898 6.57385 5.42019 6.57385 4.69098V0H8V4.71354C8 5.81862 7.70685 6.65308 7.12054 7.2169C6.53424 7.78072 5.6627 8.06263 4.50594 8.06263Z" fill={values.decoration === "underline" ? "#282B31" : "#7D8492"} fill-opacity={values.decoration === "underline" ? "1" : "0.6"} />
                        </svg>
                    </div>
                    <div onClick={(() => { setDecoration("line-through") })} className="fontStyle-aliignment" style={{ height: "28px", width: "28px", border: values.decoration === "line-through"?"1px solid #e27841":"1px solid #7d84924b", borderRadius: "2px" ,cursor: disableCursor()}}>
                        <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.531 7.953C2.90767 7.953 2.343 7.876 1.837 7.722C1.331 7.56067 0.891 7.33333 0.517 7.04L0.902 6.138C1.15133 6.32867 1.408 6.48633 1.672 6.611C1.94333 6.73567 2.22933 6.831 2.53 6.897C2.838 6.95567 3.17167 6.985 3.531 6.985C4.147 6.985 4.598 6.875 4.884 6.655C5.17733 6.435 5.324 6.14533 5.324 5.786C5.324 5.478 5.22133 5.23967 5.016 5.071C4.818 4.90233 4.466 4.76667 3.96 4.664L2.761 4.422C2.04967 4.27533 1.518 4.037 1.166 3.707C0.821333 3.36967 0.649 2.91133 0.649 2.332C0.649 1.86267 0.773667 1.452 1.023 1.1C1.27233 0.748 1.617 0.476667 2.057 0.286C2.50433 0.0953334 3.025 0 3.619 0C4.169 0 4.675 0.0806667 5.137 0.242C5.599 0.396 5.98767 0.627 6.303 0.935L5.929 1.804C5.599 1.518 5.247 1.309 4.873 1.177C4.499 1.03767 4.07367 0.968 3.597 0.968C3.03233 0.968 2.58867 1.08533 2.266 1.32C1.95067 1.55467 1.793 1.87367 1.793 2.277C1.793 2.59967 1.892 2.85267 2.09 3.036C2.29533 3.21933 2.63267 3.35867 3.102 3.454L4.301 3.685C5.04167 3.839 5.588 4.07733 5.94 4.4C6.292 4.71533 6.468 5.15167 6.468 5.709C6.468 6.15633 6.347 6.54867 6.105 6.886C5.87033 7.22333 5.533 7.48733 5.093 7.678C4.653 7.86133 4.13233 7.953 3.531 7.953Z" fill={values.decoration === "line-through" ? "#282B31" : "#7D8492"} fill-opacity={values.decoration === "line-through" ? "1" : "0.6"} />
                            <path d="M0 4.554H6.963V5.038H0V4.554Z" fill={values.decoration === "line-through" ? "#282B31" : "#7D8492"} fill-opacity="0.6" />
                        </svg>
                    </div>
                </div>
            </div>

            <div className="panel-div">
                <div className="panel-label">Line Height</div>
                <div className="flex" style={{ gap: "7px" }}>
                    <input
                        disabled={disableinput()}
                        type="text"
                        style={{width:"131px"}}
                        className="panel-input flex items-center"
                        onChange={((e: any) => {
                            const value = e.target.value
                            setValues((val: any) => ({ ...val, ["lineHeight"]: value }))
                        })}
                        value={values?.lineHeight && values.lineHeight}
                    ></input>
                </div>
            </div>

            <div className="panel-div">
                <div className="panel-label">Letter Spacing</div>
                <div className="flex" style={{ gap: "7px" }}>
                    <input
                        disabled={disableinput()}
                        type="number"
                        style={{width:"131px"}}
                        className="panel-input flex items-center"
                        onChange={((e: any) => {
                            const value = e.target.value
                            setValues((val: any) => ({ ...val, ["letterSpacing"]: value }))
                        })}
                        value={values?.letterSpacing && values.letterSpacing}
                    ></input>
                </div>
              </div>
            </div>
        </div>
    )
})
export default FontStylesPopper;